"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDecodedAccessToken = void 0;
var react_1 = require("react");
var context_1 = require("../context");
var useDecodedAccessToken = function () { return (0, react_1.useContext)(context_1.TokenContext); };
exports.useDecodedAccessToken = useDecodedAccessToken;
//# sourceMappingURL=useDecodedAccessToken.js.map